import UpdateBannerPage from "./update-banner.page";

export default UpdateBannerPage;
